// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Z_Qw","title":"Header_title__1sDn4","left":"Header_left__2rWOg","clinicName":"Header_clinicName__2-4bW"};